<template>
  <div>
    <div class="head-title">自动拉群</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、在自动拉群功能中设置是否自动验证、添加使用人员、设置需要推送的邀请入群内容、选择对应群活码（客户群活码）。
          </p>
          <p>
            2、当客户扫描该群活码之后就会先添加使用人员，同时客户会收到管理员提前设置的邀请入群内容，其中包括入群活码（客户群活码），然后扫码进群。<a
              class="help-link"
              href="https://www.weijub.com/index/index/news_detail?id=121"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
          <p>
            3、在整个流程中，即使在客户不入群或当客户退群时，该客户其实就已添加过企业成员，可以保持单独联系，就算群聊客户也不会轻易流失，并提供一对一的精准服务。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >新建自动拉群</el-button
          >
        </div>
        <div class="nav-r">
          <el-input
            v-model="q"
            style="width: 35.0rem; "
            prefix-icon="el-icon-search"
            placeholder="请输入任务名称搜索"
            clearable=""
            @change="getData"
          >
          <el-button type="primary" slot="append" @click="getData"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <div class="container">
        <el-table
          :data="list"
          style="margin-top: 2.0rem"
          border
          v-loading="tableLoading"
        >
          <el-table-column
            prop="name"
            label="任务名称"
            style="width:11.11%"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="skip_verify" label="自动验证" style="width:11.11%">
            <template slot-scope="scope">
              <span>{{ scope.row.skip_verify == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="user_name_array" label="使用人员" style="width:11.11%">
            <template slot-scope="scope">
              <div>
                <el-tag
                  size="mini"
                  style="margin: .2rem"
                  v-for="i in scope.row.user_name_array"
                  :key="i"
                  >{{ i }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="content"
            label="入群内容"
            style="width:11.11%"
          >
          </el-table-column>
          <el-table-column prop="url" label="活码图片" style="width:11.11%">
            <template slot-scope="scope">
              <el-image
                style="width: 7.0rem; height: 7.0rem"
                :src="scope.row.qr_code"
                :preview-src-list="[scope.row.qr_code]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="type_name" label="使用模式" style="width:11.11%">
          </el-table-column>
          <el-table-column prop="createtime" label="创建时间" style="width:11.11%">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="remark"
            label="备注"
            style="width:11.11%"
          >
          </el-table-column>
          <el-table-column label="操作"  width="300" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="onEdit(scope.row)">
                编辑
              </el-button>
              <el-button type="text" size="mini">
                <a
                  :href="`https://api.weijub.com/crm/ActiveCode/getImages?url=${scope.row.qr_code}&usertoken=${tooken.usertoken}`"
                  style="color: #317af8"
                  >下载</a
                >
              </el-button>
              <el-button @click="onDel(scope.row)" size="mini" type="text" style="color:#f00000 !important" >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            :page-sizes="[10,20,50,100]"
            @pagination="getData"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "setGroups",
  data() {
    return {
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      q: "",
      tableLoading: true,
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.getData();
  },

  methods: {
    onAdd() {
      this.$router.push({
        name: "setGroupsDetail",
      });
    },
    async getData() {
      const { data: res } = await this.axios({
        url: "/crm/ActiveCodeGroup/getActiveCode",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: this.q,
          page: this.listQuery.page,
          number_page:this.listQuery.limit,
        }),
      });
      this.tableLoading = false;
      if (res.code == 1) {
        this.list = res.data.data;
        this.total = res.data.total;
      }
    },
    async onEdit(row) {
      this.$router.push({
        name: "setGroupsDetail",
        query: {
          id: row.id,
        },
      });
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该条数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { data: res } = await this.axios({
            url: "/crm/ActiveCodeGroup/delActiveCode",
            method: "POST",
            data: this.qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              config_id: row.config_id,
              id: row.id,
            }),
          });
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getData();
          } else if (res.code == 0) {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
  },
};
</script>
<style  scoped>
.el-button--text{padding-left:.0rem !important;}
</style>
